/* eslint react/jsx-key: off */
import React from 'react';
import {
  Edit,
  FormTab,
  TabbedForm,
  TextInput,
  SelectInput,
  DeleteWithConfirmButton,
  Toolbar,
  SaveButton,
  ImageField,
  ArrayField,
  Datagrid,
  TextField
} from 'react-admin';
import {withStyles} from '@material-ui/core';
export const styles = {
  name: {display: 'inline-block'},
  email: {width: 544},
  phone: {width: 544}
};
const toolbarStyles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};
const role = localStorage.getItem('role');
const CourseEditToolbar = withStyles(toolbarStyles)(({...props}) => (
  <Toolbar {...props}>
    <SaveButton disabled={role != 'admin'} />
    {props.record.id && <DeleteWithConfirmButton />}
  </Toolbar>
));
const currentStatusList = [
  {id: false, name: 'Pending'},
  {id: true, name: 'Approved'}
];
const CourseEdit = ({classes, ...props}) => (
  <Edit title="Edit Course Request" actions={false} undoable={false} mutationMode="pessimistic" {...props}>
    <TabbedForm toolbar={<CourseEditToolbar />}>
      <FormTab label="Details">
        <TextInput disabled source="id" />
        <TextInput disabled source="vendorId" label="Vendor Id" />
        <TextInput disabled source="vendorDetails[0].vendorName" label="Vendor Name" />
        <TextInput disabled source="courseName" label="Course Name" />
        <TextInput disabled source="rating" label="Rating" />
        <TextInput disabled source="description" label="Description" multiline fullWidth rows={4} />
        <SelectInput source="isAdminApproved" choices={currentStatusList} />
        <ArrayField source="trainingSpecificationDetails" label="Training Specifications">
          <Datagrid>
            <TextField source="specificationName" label="Specification Name" />
            <TextField source="type" label="Type" />
            <TextField source="duration" label="Duration" />
            <TextField source="durationPeriod" label="Duration Period" />
            <TextField source="cost" label="Cost (₹)" />
            <TextField source="description" label="Description" />
          </Datagrid>
        </ArrayField>
      </FormTab>
      <FormTab label="Training Specifications">
        <ArrayField source="trainingSpecificationDetails" label="Training Specifications">
          <Datagrid>
            <TextField source="specificationName" label="Specification Name" />
            <TextField source="type" label="Type" />
            <TextField source="duration" label="Duration" />
            <TextField source="durationPeriod" label="Duration Period" />
            <TextField source="cost" label="Cost (₹)" />
            <TextField source="description" label="Description" />
          </Datagrid>
        </ArrayField>
      </FormTab>
      <FormTab label="Images">
        <ImageField source="courseImagePath" label="" />
      </FormTab>
    </TabbedForm>
  </Edit>
);

CourseEdit.propTypes = {};

export default withStyles(styles)(CourseEdit);
